export interface BankingVerificationAskingResponse {
    id: string;
    noPersonne: string;
    urlParcours: string;
}

export interface GetBankingVerificationAskingResponse {
    id: string;
    informationsSupplementaires: {
        iban: string;
        nomBanque: string;
        titulaire: string;
    };
    statut: OpenBankingStatus;
}

export interface BankingVerificationApiPayload {
    demande: {
        noPersonne: string;
        urlCallBack?: string;
    };
}

export enum OpenBankingStatus {
    ABANDONNE = 'ABANDONNE',
    CREE = 'CREE',
    EN_COURS = 'EN_COURS',
    ERREUR = 'ERREUR',
    EXPIRE = 'EXPIRE',
    REALISE = 'REALISE',
    REFUSE = 'REFUSE',
}
